import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { AccountRoutePage } from "../app/accountRoute";

export const Route = createFileRoute("/account")({
  component: AccountRoute,
});

function AccountRoute(): JSX.Element {
  const search = Route.useSearch();
  return <AccountRoutePage search={search} />;
}
